import { clearNextStatesAction, clearPreviousStatesAction } from 'editor/src/store/editorModules/undoRedo/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const clearStatesOperation = () => (dispatch: ThunkDispatch) => {
  dispatch(clearNextStatesAction());
  dispatch(clearPreviousStatesAction());
};

export default clearStatesOperation;
